/**
 * @internal
 * Construct tracker of proper type derived from Tracker while iterating over trackers.
 * Loads necessary .js files defining tracker types
 */
import { Factory } from './Factory'

export default new Factory()
